import React from 'react';
import { useTranslation } from '@hooks/useTranslation';

interface BudgetSubTabNavigationProps {
  activeSubTab: 'received' | 'delegated';
  setActiveSubTab: (tab: 'received' | 'delegated') => void;
}

export const BudgetSubTabNavigation: React.FC<BudgetSubTabNavigationProps> = ({
  activeSubTab,
  setActiveSubTab,
}) => {
  const tTaskDetail = useTranslation('taskDetail');

  return (
    <div className="border-b border-gray-200">
      <nav className="-mb-px flex space-x-8">
        <button
          type="button"
          onClick={() => setActiveSubTab('received')}
          className={`py-2 px-1 border-b-2 font-medium text-sm ${
            activeSubTab === 'received'
              ? 'border-purple-500 text-purple-600'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
          }`}>
          {tTaskDetail.budget.subTabReceived}
        </button>
        <button
          type="button"
          onClick={() => setActiveSubTab('delegated')}
          className={`py-2 px-1 border-b-2 font-medium text-sm ${
            activeSubTab === 'delegated'
              ? 'border-blue-500 text-blue-600'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
          }`}>
          {tTaskDetail.budget.subTabDelegated}
        </button>
      </nav>
    </div>
  );
};